module.exports = __webpack_public_path__ + "img/cont-01-consumo.86101f8b.svg";